const cleanLocalStorage = () => {
  let token = window.localStorage.getItem("token");
  window.localStorage.clear();
  window.localStorage.setItem("token", token);
};

export default cleanLocalStorage;
